import React from 'react';
import { getColor } from 'core/utils/Styles';
import PropTypes from 'prop-types';

const CameraSVG = props => (
	<svg width="24" height="24" viewBox="0 0 24 24" {...props}>
		<path d="M334,456 L320,456 C317.243,456 315,458.243 315,461 L315,475 C315,477.757 317.243,480 320,480 L334,480 C336.757,480 339,477.757 339,475 L339,461 C339,458.243 336.757,456 334,456 Z M327,461 C329.761,461 332,463.239 332,466 C332,468.761 329.761,471 327,471 C324.239,471 322,468.761 322,466 C322,463.239 324.239,461 327,461 Z M320,460 C320.552,460 321,460.448 321,461 C321,461.552 320.552,462 320,462 C319.448,462 319,461.552 319,461 C319,460.448 319.448,460 320,460 Z M335,476 L319,476 L319,474 L335,474 L335,476 Z" transform="translate(-315 -456)"/>
	</svg>
);

CameraSVG.propTypes = {
	fill: PropTypes.string,
};

CameraSVG.defaultProps = {
	fill: getColor('primaryBrand'),
};

export default CameraSVG;
